import React, { useEffect, useState } from 'react';
import headerImage from '../assets/images/headerImage.png'
import important from '../assets/images/important.png'
import goals1 from '../assets/images/goals1.png'
import goals2 from '../assets/images/goals2.png'
import goals3 from '../assets/images/goals3.png'
import goals4 from '../assets/images/goals4.png'
import abdelaziz from '../assets/images/speakers/abdelaziz.png'
import abdullahBnSaud from '../assets/images/speakers/abdullahBnSaud.png'
import fahd from '../assets/images/speakers/fahd.png'
import haitham from '../assets/images/speakers/haitham.png'

import aoaaf from '../assets/images/sponsers/aoaaf.png'
import channels from '../assets/images/sponsers/channels.png'
import commercial from '../assets/images/sponsers/commercial.png'
import compeate from '../assets/images/sponsers/compeate.png'
import realEstateGeneral from '../assets/images/sponsers/realEstateGeneral.png'
import resolutionscommittee from '../assets/images/sponsers/resolutionscommittee.png'
import stcLogo from '../assets/images/sponsers/stcLogo.png'
import ConferenceStats from '../components/ConferenceStats'
import AnimatedSection, { AnimatedGroup, AnimatedItem } from '../components/AnimatedSection'
import { motion } from 'motion/react'
import { Link } from 'react-router-dom';

const CONFERENCE_START = new Date('2026-09-13T11:00:00+03:00');

const getCountdown = () => {
    const remaining = Math.max(0, CONFERENCE_START.getTime() - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);

    return {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
    };
};

const Home = () => {
    const participants = [stcLogo, commercial , aoaaf , realEstateGeneral , compeate, channels , resolutionscommittee];
    const [participantStartIndex, setParticipantStartIndex] = useState(0);
    const [countdown, setCountdown] = useState(getCountdown);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCountdown(getCountdown());
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    const nextParticipant = () => {
        setParticipantStartIndex((currentIndex) => (currentIndex + 1) % participants.length);
    };

    const previousParticipant = () => {
        setParticipantStartIndex((currentIndex) => (currentIndex - 1 + participants.length) % participants.length);
    };

    const visibleParticipants = [
        ...participants.slice(participantStartIndex),
        ...participants.slice(0, participantStartIndex),
    ];

    return (
        <>
            <header className='relative flex min-h-[720px] w-full items-center justify-center overflow-hidden sm:min-h-[780px] lg:h-[913px]'>
                <img src={headerImage} alt="headerImage" className='absolute inset-0 h-full w-full object-cover' />
                <motion.div
                    className='relative z-10 mx-auto w-full max-w-[920px] px-5 pt-24 sm:px-8 lg:px-0 lg:pt-0'
                    initial={{ opacity: 0, y: 36 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1.35, ease: [0.22, 1, 0.36, 1] }}
                >
                    <div className='flex justify-center'>
                        <div className=' text-white text-xs font-normal text-center mb-5 mx-auto bg-[#005CA4] rounded-full inline-block px-7 py-1'>
                            13 سبتمبر 2026
                        </div>
                    </div>
                    <div className='mx-auto mb-5 text-center text-base font-medium leading-relaxed text-white sm:text-lg'>
                        <p>تحت رعاية رئيس جامعة الملك سعود المُكلَّف أ.د. علي بن محمد مسملي</p>
                        <p>تعقد كلية الحقوق والعلوم السياسية</p>
                    </div>
                    <h1 className='mx-auto mb-6 max-w-[820px] text-center text-2xl font-bold leading-snug text-white sm:text-3xl lg:mb-8 lg:text-4xl lg:leading-tight'>
                        مؤتمر الجوانب القانونية للحوكمة ﻓﻲ اﻟﻤﻤﻠﻜﺔ اﻟﻌﺮﺑﻴﺔ <br className='hidden sm:block' /> اﻟﺴﻌﻮدﻳﺔ : ﺗﻜﺎﻣﻞ اﻟﻘﻄﺎﻋﺎت
                    </h1>
                    <h2 className='mb-8 flex items-center justify-center gap-2 text-center text-base font-bold text-white sm:text-xl'>
                        <svg className='h-6 w-5 shrink-0 sm:h-[26px] sm:w-[21px]' viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M10.5 12.1875C9.05012 12.1875 7.875 11.0963 7.875 9.75C7.875 8.40369 9.05012 7.3125 10.5 7.3125C11.9499 7.3125 13.125 8.40369 13.125 9.75C13.125 11.0963 11.9499 12.1875 10.5 12.1875ZM10.5 5.6875C8.08412 5.6875 6.125 7.50587 6.125 9.75C6.125 11.9941 8.08412 13.8125 10.5 13.8125C12.9159 13.8125 14.875 11.9941 14.875 9.75C14.875 7.50587 12.9159 5.6875 10.5 5.6875ZM10.5 23.5625C9.04487 23.5698 1.75 13.1471 1.75 9.75C1.75 5.26337 5.66737 1.625 10.5 1.625C15.3326 1.625 19.25 5.26337 19.25 9.75C19.25 13.1016 11.9324 23.5698 10.5 23.5625ZM10.5 0C4.70137 0 0 4.36556 0 9.75C0 13.8271 8.75437 26.0089 10.5 26C12.2185 26.0089 21 13.7719 21 9.75C21 4.36556 16.2986 0 10.5 0Z" fill="white"/>
                        </svg>
                        الرياض، المملكة العربية السعودية
                    </h2>

                    <div className='mb-8 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-6'>
                        <Link to='/registration' className='rounded-lg bg-[#3E83B9] px-8 py-3 text-center text-base font-semibold text-white sm:px-10'>
                            سجل الان
                        </Link>
                        <a href='/about' className='rounded-lg border border-[#3E83B9] bg-transparent px-8 py-3 text-center text-base font-semibold text-white sm:px-10'>
                            اعرف المزيد
                        </a>
                    </div>
                    <div className='grid grid-cols-2 justify-items-center gap-3 sm:flex sm:justify-center sm:gap-6'>
                        <div className='rounded-lg border border-[#AFAFAF] bg-transparent px-4 py-3 text-center text-white backdrop-blur-sm sm:px-8 lg:px-10'>
                            <span className='text-2xl font-semibold sm:text-[32px]'> {countdown.seconds} </span>
                            <br />
                            <span className='text-base font-medium sm:text-lg'> ثوانٍ </span>
                        </div>
                        <div className='rounded-lg border border-[#AFAFAF] bg-transparent px-4 py-3 text-center text-white backdrop-blur-sm sm:px-8 lg:px-10'>
                            <span className='text-2xl font-semibold sm:text-[32px]'> {countdown.minutes} </span>
                            <br />
                            <span className='text-base font-medium sm:text-lg'> دقائق </span>
                        </div>
                        <div className='rounded-lg border border-[#AFAFAF] bg-transparent px-4 py-3 text-center text-white backdrop-blur-sm sm:px-8 lg:px-10'>
                            <span className='text-2xl font-semibold sm:text-[32px]'> {countdown.hours} </span>
                            <br />
                            <span className='text-base font-medium sm:text-lg'> ساعات </span>
                        </div>
                        <div className='rounded-lg border border-[#AFAFAF] bg-transparent px-4 py-3 text-center text-white backdrop-blur-sm sm:px-8 lg:px-10'>
                            <span className='text-2xl font-semibold sm:text-[32px]'> {countdown.days} </span>
                            <br />
                            <span className='text-base font-medium sm:text-lg'> أيام </span>
                        </div>
                    </div>
                </motion.div>
            </header>

            <ConferenceStats />

            <AnimatedSection className="bg-white py-20 px-6">
                <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-12 lg:gap-20">
                    <div className="w-full md:w-1/2 text-right">
                    <h2 className="text-[42px] font-[400] text-gray-900 mb-6">
                        أهمية المؤتمر
                    </h2>
                    <p className="text-[22px] font-[400] text-gray-700 leading-[1.8]">
                        يمثل مؤتمر الحوكمة الذي تنظمه كلية الحقوق والعلوم السياسية تجسيداً لتوجيهات القيادة الرشيدة في ترسيخ الحوكمة من خلال تأهيل الشباب، ومناقشة تشريعات وتطبيقات الحوكمة
                    </p>
                    </div>

                    <div className="w-full md:w-1/2">
                        <div className="w-full aspect-video ">
                            <img src={important} alt='أهمية المؤتمر' />
                        </div>
                    </div>

                </div>
            </AnimatedSection>

            <AnimatedSection className="bg-[#F8F8F8] py-20 px-6">
                <div className="max-w-6xl mx-auto">
                    <h2 className="text-[42px] font-[400] text-black text-right mb-12">
                    الاهداف الرئيسية للمؤتمر
                    </h2>
                    <AnimatedGroup className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    
                    <AnimatedItem className="bg-white rounded-[24px] p-10 shadow-sm border border-gray-100">
                        <div className="flex justify-start mb-6 w-[76px]">
                            <img src={goals1} className='w-full' alt='' />
                        </div>
                        <p className="text-[27px] font-[400] text-[#111827] leading-[1.7] text-right">
                        تعزيز الحوار وتبادل الخبرات بين الخبراء والأكاديميين والمهنيين.
                        </p>
                    </AnimatedItem>

                    <AnimatedItem className="bg-white rounded-[24px] p-10 shadow-sm border border-gray-100">
                        <div className="flex justify-start mb-6 w-[76px]">
                            <img src={goals2} className='w-full' alt='' />
                        </div>
                        <p className="text-[27px] font-[400] text-[#111827] leading-[1.7] text-right">
                        مراجعة تطبيقات الحوكمة في بعض القطاعات مثل القطاع العام، والقطاع الخاص بهدف تمكين الأعمال وكذلك القطاع غير الربحي.
                        </p>
                    </AnimatedItem>

                    <AnimatedItem className="bg-white rounded-[24px] p-10 shadow-sm border border-gray-100">
                        <div className="flex justify-start mb-6 w-[76px]">
                            <img src={goals3} className='w-full' alt='' />
                        </div>
                        <p className="text-[27px] font-[400] text-[#111827] leading-[1.7] text-right">
                        تقديم ورش عمل مصاحبة تسهم في تعزيز الفائدة العلمية والتطبيقية، وتحقيق أقصى استفادة للمشاركين، بما يجعل يوم المؤتمر محطة متكاملة للتعلم والتفاعل وتبادل الخبرات.
                        </p>
                    </AnimatedItem>

                    <AnimatedItem className="bg-white rounded-[24px] p-10 shadow-sm border border-gray-100">
                        <div className="flex justify-start mb-6 w-[76px]">
                            <img src={goals4} className='w-full' alt='' />
                        </div>
                        <p className="text-[27px] font-[400] text-[#111827] leading-[1.7] text-right">
                        إبراز كيفية اختلاف نماذج الحوكمة بين الجهات، حتى داخل القطاع الواحد، بما يعكس تنوع الأطر التشريعية وآليات التطبيق، ويسهم في تعميق فهم الحوكمة من حيث التشريع والتنفيذ.
                        </p>
                    </AnimatedItem>

                    </AnimatedGroup>
                </div>
            </AnimatedSection>

            {/* <AnimatedSection className="bg-white py-20 px-6">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-[42px] font-normal mb-16">
                        من ابرز المتحدثين
                    </h2>
                    <AnimatedGroup className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                        <AnimatedItem className="flex flex-col items-center text-center">
                            <div className="w-full aspect-square rounded-[24px] overflow-hidden mb-6 flex items-center justify-center">
                                <img src={abdelaziz} className='w-full' alt='' />
                            </div>
                            <h3 className="text-xl font-normal mb-2 leading-snug">
                            معالي الأستاذ عبدالعزيز بن سعود الدحيم
                            </h3>
                            <p className="text-xs font-semibold">
                             مساعد وزير التجارة
                            </p>
                        </AnimatedItem>

                    <AnimatedItem className="flex flex-col items-center text-center">
                        <div className="w-full aspect-square rounded-[24px] overflow-hidden mb-6 flex items-center justify-center">
                            <img src={abdullahBnSaud} className='w-full' alt='' />
                        </div>
                        <h3 className="text-xl font-normal mb-2 leading-snug">
                        سعادة المهندس عبدالله بن سعود الحماد
                        </h3>
                        <p className="text-xs font-semibold">
                        الرئيس التنفيذي للهيئة العامة للعقار
                        </p>
                    </AnimatedItem>

                    <AnimatedItem className="flex flex-col items-center text-center">
                        <div className="w-full aspect-square rounded-[24px] overflow-hidden mb-6 flex items-center justify-center">
                            <img src={fahd} className='w-full' alt='' />
                        </div>
                        <h3 className="text-xl font-normal mb-2 leading-snug">
                        الدكتور فهد بن محمد الماجد
                        </h3>
                        <p className="text-xs font-semibold">
                        نائب محافظ هيئة الأوقاف
                        </p>
                    </AnimatedItem>

                    <AnimatedItem className="flex flex-col items-center text-center">
                        <div className="w-full aspect-square rounded-[24px] overflow-hidden mb-6 flex items-center justify-center">
                            <img src={haitham} className='w-full' alt='' />
                        </div>
                        <h3 className="text-xl font-normal mb-2 leading-snug">
                        سعادة الاستاذ هيثم الفايز
                        </h3>
                        <p className="text-xs font-semibold">
                        الرئيس التنفيذي لشركة وقف سليمان الراجحي القابضة
                        </p>
                    </AnimatedItem>

                    </AnimatedGroup>
                </div>
            </AnimatedSection> */}

            <AnimatedSection className="bg-white py-20 px-6">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-[28px] font-bold mb-12">
                    الجهات المشاركة
                    </h2>
                    
                    <div className="flex items-center gap-4">
                    <button type="button" onClick={nextParticipant} aria-label="Next participants" className="flex-shrink-0 w-10 h-10 flex items-center justify-center border border-gray-200 rounded-lg bg-transparent text-gray-500 hover:bg-gray-50 transition-colors">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M9 18l6-6-6-6" />
                        </svg>
                    </button>
                    
                    <div className="flex flex-1 items-center justify-between gap-4 overflow-hidden">
                        {visibleParticipants.map((item, i) => (
                        <div 
                            key={i} 
                            className="flex-shrink-0 w-[153px] h-[88px] bg-white border border-[#D2D6DB] rounded-[15px] flex items-center justify-center"
                        >
                            <img src={item} className='w-3/4' alt='' />
                        </div>
                        ))}
                    </div>

                    <button type="button" onClick={previousParticipant} aria-label="Previous participants" className="flex-shrink-0 w-10 h-10 flex items-center justify-center border border-gray-200 rounded-lg bg-transparent text-gray-500 hover:bg-gray-50 transition-colors">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M15 18l-6-6 6-6" />
                        </svg>
                    </button>
                    </div>
                </div>
            </AnimatedSection>
        </>
    );
};

export default Home;
